import { render, staticRenderFns } from "./RecipesSort.vue?vue&type=template&id=71425476&"
import script from "./RecipesSort.vue?vue&type=script&lang=js&"
export * from "./RecipesSort.vue?vue&type=script&lang=js&"
import style0 from "./RecipesSort.vue?vue&type=style&index=0&id=71425476&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports